import type { CandidateStatus } from 'services/candidates';
import type { CandidateAction, CandidateSecondaryAction } from 'services/candidates/types';

export type AvailableActions = Record<
  CandidateStatus,
  {
    actions: CandidateAction[];
    extraOptions: Partial<Record<CandidateAction, CandidateSecondaryAction[]>>;
  }
>;

/*
 * This function returns an object that defines the available actions
 * and 'more options' for CandidateDetails component basing it on the
 * candidate's current status
 */

export const getAvailableActions = ({
  shouldShowScheduleInterviewButton,
}: {
  shouldShowScheduleInterviewButton?: boolean;
}): AvailableActions => {
  return {
    NEW: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': [
          'MATCH',
          'SHORTLIST-TO-ANOTHER-SEARCH',
          'SHARE-PROFILE',
          ...(shouldShowScheduleInterviewButton ? ['SCHEDULE-INTERVIEW' as const] : []),
        ],
      },
    },
    SHORTLISTED: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': [
          'MATCH',
          'SHORTLIST-TO-ANOTHER-SEARCH',
          'SHARE-PROFILE',
          ...(shouldShowScheduleInterviewButton ? ['SCHEDULE-INTERVIEW' as const] : []),
        ],
      },
    },
    CONTACTED: {
      actions: ['SHARE-PROFILE', 'CONTACT', 'MATCH'],
      extraOptions: {},
    },
    MATCHED: {
      actions: ['DOWNLOAD', 'CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': [
          'RETRY-TO-SEND-TO-ATS',
          'SHARE-PROFILE',
          ...(shouldShowScheduleInterviewButton ? ['SCHEDULE-INTERVIEW' as const] : []),
        ],
      },
    },
    HIDDEN: {
      actions: ['SHARE-PROFILE', 'MATCH'],
      extraOptions: {},
    },
    INVISIBLE: {
      actions: [],
      extraOptions: {},
    },
  };
};

export const getAvailableActionsForInbox = (): AvailableActions => {
  return {
    NEW: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': ['SHORTLIST-TO-ANOTHER-SEARCH', 'SHARE-PROFILE', 'NOTE'],
      },
    },
    SHORTLISTED: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': ['SHORTLIST-TO-ANOTHER-SEARCH', 'SHARE-PROFILE', 'NOTE'],
      },
    },
    CONTACTED: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': ['SHARE-PROFILE', 'NOTE'],
      },
    },
    MATCHED: {
      actions: ['CONTACT', 'SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': ['DOWNLOAD', 'RETRY-TO-SEND-TO-ATS', 'SHARE-PROFILE', 'NOTE'],
      },
    },
    HIDDEN: {
      actions: ['SHOW-MORE'],
      extraOptions: {
        'SHOW-MORE': ['SHARE-PROFILE', 'NOTE'],
      },
    },
    INVISIBLE: {
      actions: [],
      extraOptions: {},
    },
  };
};
